import React from 'react';
import { Col, Form, Input, Row } from 'antd';
import { ROW_GUTTER } from 'constants/ThemeConstant';

const LocationCoordinateForm = ({ location, setLocation, onSubmit }) => (
  <Form
    layout="vertical"
    onFinish={onSubmit}
    id="chat-location-manual-form"
  >
    <Row gutter={ROW_GUTTER}>
      <Col span={12}>
        <Form.Item
          label="Latitude"
          name="latitude"
          rules={[{ required: true, message: 'Please enter latitude' }]}
        >
          <Input
            type="number"
            step="any"
            placeholder="e.g., 37.7749"
            value={location?.latitude}
            onChange={(e) => setLocation({ ...location, latitude: e.target.value })}
          />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label="Longitude"
          name="longitude"
          rules={[{ required: true, message: 'Please enter longitude' }]}
        >
          <Input
            type="number"
            step="any"
            placeholder="e.g., -122.4194"
            value={location?.longitude}
            onChange={(e) => setLocation({ ...location, longitude: e.target.value })}
          />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item label="Location Name (Optional)">
          <Input
            placeholder="e.g., Our Office"
            value={location?.name}
            onChange={(e) => setLocation({ ...location, name: e.target.value })}
          />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item label="Address (Optional)">
          <Input.TextArea
            placeholder="123 Main St"
            autoSize={{ minRows: 1, maxRows: 4 }}
            value={location?.address}
            onChange={(e) => setLocation({ ...location, address: e.target.value })}
          />
        </Form.Item>
      </Col>
    </Row>
  </Form>
);

export default LocationCoordinateForm;
